<div
   class="modal-header p-0"
   style="justify-content: end; margin-top: -5px; margin-bottom: 5px">
   <button
      type="button"
      class="btn-close position-static"
      data-bs-dismiss="modal"
      aria-label="Close"
      style="padding-bottom: 4px"
      (click)="onClose()">
      <span aria-hidden="true">×</span>
   </button>
</div>

<p-tabs value="0">
   <p-tablist>
      <p-tab value="0">CSV</p-tab>
      <p-tab value="1">DBX</p-tab>
   </p-tablist>
   <p-tabpanels>
      <p-tabpanel value="0">
         <div
            class="modal-body p-0"
            style="padding-left: 20px !important; padding-right: 20px !important">
            <div class="d-flex flex-column">
               <h3 class="pb-3">Import CSV File</h3>
               <div class="p-fluid pb-4">
                  <div class="flex flex-nowrap">
                     <p-dropdown
                        [options]="csvUploadOptions"
                        [(ngModel)]="selectedCsvUploadType"
                        placeholder="Select CSV Type"
                        displayLabel="label"
                        style="width: 250px; margin-right: 15px"
                        class="mb-3"
                        (onChange)="resetErrorsAndWarnings()"></p-dropdown>
                     <div *ngIf="selectedCsvUploadType">
                        <p-button
                           label="Download Sample CSV"
                           icon="pi pi-download"
                           severity="info"
                           (click)="downloadSampleCsv(selectedCsvUploadType.fileUploadType)"></p-button>
                        <vc-file-upload
                           #fileUpload
                           accept=".csv,text/*"
                           [isSubmitting]="isSubmittingCsv"
                           [isValidating]="isValidating"
                           [errorMessages]="errorMessages"
                           [warningMessages]="warningMessages"
                           (onUpload)="uploadFile($event, selectedCsvUploadType.fileUploadType)"
                           (onSelectFile)="selectFile($event, selectedCsvUploadType.fileUploadType)" />
                     </div>
                  </div>
               </div>
               <div class="csv-schema pt-4">
                  <h3 *ngIf="selectedCsvUploadType">Expected Schema for {{ selectedCsvUploadType.label }}</h3>
                  <table
                     class="table-auto border-collapse border border-gray-300 w-full"
                     *ngIf="selectedCsvUploadType">
                     <thead>
                        <tr class="bg-gray-100">
                           <th class="border border-gray-300 px-2 py-1">Column Name</th>
                           <th class="border border-gray-300 px-2 py-1">Type</th>
                           <th class="border border-gray-300 px-2 py-1">Required</th>
                           <th class="border border-gray-300 px-2 py-1">Description</th>
                        </tr>
                     </thead>
                     <tbody *ngIf="getSelectedCsvSchema(selectedCsvUploadType.fileUploadType)">
                        <tr *ngFor="let column of getSelectedCsvSchema(selectedCsvUploadType.fileUploadType)">
                           <td class="border border-gray-300 px-2 py-1">{{ column.name }}</td>
                           <td class="border border-gray-300 px-2 py-1">{{ column.type }}</td>
                           <td class="border border-gray-300 px-2 py-1">
                              {{ column.required ? "Yes" : "No" }}
                           </td>
                           <td class="border border-gray-300 px-2 py-1">{{ column.description }}</td>
                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </p-tabpanel>
      <p-tabpanel value="1">
         <div
            class="modal-body p-0"
            style="padding-left: 20px !important; padding-right: 20px !important">
            <div class="d-flex flex-column">
               <h3 class="pb-3">Pricing Update DBX Import</h3>
               <p>You will receive an email on completion</p>
               <div class="p-fluid pb-4">
                  <p-dropdown
                     [options]="pipelines"
                     [ngModel]="selectedPipeline"
                     (ngModelChange)="onSetPipeline($event)"
                     placeholder="Pipeline to Run"
                     displayLabel="label"
                     style="width: 250px; margin-right: 15px"
                     class="mb-3"></p-dropdown>
                  <br />
                  <vc-text-input
                     label="Source (Databricks View)"
                     placeholder="revenue_analytics.default.pricing_updates"
                     type="text"
                     required="true"
                     [(ngModel)]="sourceInputValue" />

                  <vc-spinner *ngIf="isSubmittingDbx.value?.source.length > 0"></vc-spinner>
               </div>
            </div>
         </div>
         <p-button
            icon="pi pi-save"
            (click)="onSubmitDbx()"
            label="Process"
            severity="primary"
            class="save-button px-2"
            [disabled]="isSubmittingDbx.value?.source.length > 0 || sourceInputValue?.length === 0" />
         <p-button
            icon="pi pi-times"
            (click)="onClose()"
            label="Cancel"
            class="px-2"
            severity="secondary"></p-button>
         <div
            class="dbx-schema mt-4"
            *ngIf="selectedSchema">
            <h2>
               Table:
               <code>{{ selectedSchema.tableName }}</code>
            </h2>
            <table class="table-auto border-collapse border border-gray-300 w-full">
               <thead>
                  <tr class="bg-gray-100">
                     <th class="border border-gray-300 px-2 py-1">Column Name</th>
                     <th class="border border-gray-300 px-2 py-1">Type</th>
                     <th class="border border-gray-300 px-2 py-1">Nullable</th>
                  </tr>
               </thead>
               <tbody>
                  <tr *ngFor="let column of selectedSchema.schema">
                     <td class="border border-gray-300 px-2 py-1">{{ column.name }}</td>
                     <td class="border border-gray-300 px-2 py-1">{{ column.type }}</td>
                     <td class="border border-gray-300 px-2 py-1">{{ column.nullable }}</td>
                  </tr>
               </tbody>
            </table>
         </div>
      </p-tabpanel>
   </p-tabpanels>
</p-tabs>
